import { render } from "./PaymentRecords.vue?vue&type=template&id=2d60b35c&ts=true"
import script from "./PaymentRecords.vue?vue&type=script&lang=ts"
export * from "./PaymentRecords.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__